// Todo: try to find a solution for browsers and urls without https that doesn't support navigator clipboard
export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text)
  } catch (e) {
    console.warn('Error when trying to copy from navigator.clipboard:', e)
    return false
  }
  return true
}
